export class EnvUtils {

    public static envCdToTokenKey(param?) {
        const envCd = global['envCd'];
        if (envCd === undefined) {
            console.error('Failed to configure environment')
            return 'nan';
        } else {
            let tokenKey = '';
            switch (envCd) {
                case 'loc':
                case 'devecs':
                case 'dev':
                    tokenKey = 'access_token_dev';
                    break;
                case 'deveks':
                    tokenKey = 'access_token_dev';
                    break;
                case 'prdecs':
                case 'prdeks':
                case 'prd':
                    tokenKey = 'access_token';
                    break;
                case 'chn':
                case 'sec-prod':
                default:
                    tokenKey = 'access_token';
                    break;
            }
            return tokenKey;
        }
    }

    public static envCdToAccessToken() {
        return $.cookie(this.envCdToTokenKey());
    }

    public static envCdToRefreshKey(param?) {
        const envCd = global['envCd'];
        if (envCd === undefined) {
            console.error('Failed to configure environment')
            return 'nan';
        } else {
            let tokenKey = '';
            switch (envCd) {
                case 'loc':
                case 'devecs':
                case 'dev':
                    tokenKey = 'refresh_token_dev';
                    break;
                case 'deveks':
                    tokenKey = 'refresh_token_dev';
                    break;
                case 'prdecs':
                case 'prdeks':
                case 'prd':
                    tokenKey = 'refresh_token';
                    break;
                case 'chn':
                case 'sec-prod':
                default:
                    tokenKey = 'refresh_token';
                    break;
            }
            return tokenKey;
        }
    }

    public static envCdToRefreshToken() {
        return $.cookie(this.envCdToRefreshKey());
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/env.utils.ts